// [DEV MN]
var body = document.body;

// Dark Mode functionality
if (document.querySelector(".dark-mode-wrapper input")) {
  document
    .querySelector(".dark-mode-wrapper input")
    .addEventListener("change", (e) => {
      var darkModeValue = e.target.value;
      if (darkModeValue == "light-mode") {
        body.classList.add("dark-mode");
        sessionStorage.setItem("themeMode", "dark-mode");
        e.target.value = "dark-mode";
      } else {
        body.classList.remove("dark-mode");
        sessionStorage.setItem("themeMode", "light-mode");
        e.target.value = "light-mode";
      }
    });
}

if (document.querySelector(".dark-mode-wrapper input")) {
  if (
    sessionStorage.getItem("themeMode") != null &&
    sessionStorage.getItem("themeMode") != ""
  ) {
    if (sessionStorage.getItem("themeMode") == "dark-mode") {
      body.classList.add("dark-mode");
      document
        .querySelector(".dark-mode-wrapper input")
        .setAttribute("checked", true);
      document.querySelector(".dark-mode-wrapper input").value = "dark-mode";
    } else {
      document.querySelector(".dark-mode-wrapper input").value = "light-mode";
    }
  } else {
    document.querySelector(".dark-mode-wrapper input").value = "light-mode";
  }
}

// Sale functionality

if (body.classList.contains("website-on-sale")) {
  var saleDate = body.getAttribute("data-sale-date");
  
  // Set the date we're counting down to
  var countDownDate = new Date(saleDate).getTime();
console.log(countDownDate);
  // Update the count down every 1 second
  var x = setInterval(function () {
    // Get today's date and time
    var now = new Date().getTime();
    

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Output the result in an element
    document.querySelectorAll(".days").forEach((d) => {
      d.innerText = `${days}`;
    });
    document.querySelectorAll(".hours").forEach((h) => {
      h.innerText = `${hours}`;
    });
    document.querySelectorAll(".minutes").forEach((m) => {
      m.innerText = `${minutes}`;
    });
    document.querySelectorAll(".seconds").forEach((s) => {
      s.innerText = `${seconds}`;
    });

    document.querySelectorAll(".days-label").forEach((d) => {
      d.innerText = `days`;
    });
    document.querySelectorAll(".hours-label").forEach((h) => {
      h.innerText = `hours`;
    });
    document.querySelectorAll(".minutes-label").forEach((m) => {
      m.innerText = `minutes`;
    });
    document.querySelectorAll(".seconds-label").forEach((s) => {
      s.innerText = `seconds`;
    });

    // document.querySelectorAll('.sale-timer-wrapper').forEach(sale => {
    //     sale.style.opacity = 1
    // })

    // If the count down is over, write some text
    if (distance < 0) {
      clearInterval(x);
      // Remove Sale
      body.classList.remove("website-on-sale");
    }
  }, 1000);
}


// // Full page scroll settings

var activeCategory;

// Finding active category

// for marketing or campaigns switch category by using this format e-g this link (https://outfitters.com.pk/?category=men) shows men category
if (window.location.href.includes("?category=men")) {
  activeCategory = "men";
  setCookie("activeCategory", activeCategory, 365);
} else if (window.location.href.includes("?category=women")) {
  activeCategory = "women";
  setCookie("activeCategory", activeCategory, 365);
} else if (window.location.href.includes("?category=juniors")) {
  activeCategory = "juniors";
  setCookie("activeCategory", activeCategory, 365);
}
// when cookie of active category is available
else if (
  getCookie("activeCategory") != null &&
  getCookie("activeCategory") != "null" &&
  getCookie("activeCategory") != ""
) {
  activeCategory = getCookie("activeCategory");
}
// when active category is selected from them settings
else {
  activeCategory = body.getAttribute("data-activeCategory");
  setCookie("activeCategory", activeCategory, 365);
}

// Selecting relevant category links on the basis of active category
if (
  getCookie("activeCategory") != null &&
  getCookie("activeCategory") != "null" &&
  getCookie("activeCategory") != ""
) {
  var rightButton = document.querySelector(".category-right-icon");
  var leftButton = document.querySelector(".category-left-icon");
  if (getCookie("activeCategory") == "men") {
    if (rightButton) {
      rightButton.setAttribute("data-category", "women");
      rightButton.querySelector(".next-category").innerText = "WOMEN";
    }
    if (leftButton) {
      leftButton.setAttribute("data-category", "juniors");
      leftButton.querySelector(".prev-category").innerText = "JUNIORS";
    }

    document
      .querySelector(".special-menu-women")
      .classList.add("visually-hidden");
    document
      .querySelector(".special-menu-juniors")
      .classList.add("visually-hidden");
    document
      .querySelector(".special-menu-men")
      .classList.remove("visually-hidden");
  } else if (getCookie("activeCategory") == "women") {
    if (rightButton) {
      rightButton.setAttribute("data-category", "juniors");
      rightButton.querySelector(".next-category").innerText = "JUNIORS";
    }
    if (leftButton) {
      leftButton.setAttribute("data-category", "men");
      leftButton.querySelector(".prev-category").innerText = "MEN";
    }

    document
      .querySelector(".special-menu-women")
      .classList.remove("visually-hidden");
    document
      .querySelector(".special-menu-juniors")
      .classList.add("visually-hidden");
    document
      .querySelector(".special-menu-men")
      .classList.add("visually-hidden");
  } else {
    if (rightButton) {
      rightButton.setAttribute("data-category", "men");
      rightButton.querySelector(".next-category").innerText = "MEN";
    }
    if (leftButton) {
      leftButton.setAttribute("data-category", "women");
      leftButton.querySelector(".prev-category").innerText = "WOMEN";
    }

    document
      .querySelector(".special-menu-women")
      .classList.add("visually-hidden");
    document
      .querySelector(".special-menu-juniors")
      .classList.remove("visually-hidden");
    document
      .querySelector(".special-menu-men")
      .classList.add("visually-hidden");
  }
}

// Selecting relevant menu on the basis of active category
var menuTop = document.querySelectorAll(".special-menu-item");
menuTop.forEach((item) => {
  if (
    getCookie("activeCategory") != null &&
    getCookie("activeCategory") != "null" &&
    getCookie("activeCategory") != ""
  ) {
    item.classList.remove("active");
    if (getCookie("activeCategory") == "men") {
      if (item.getAttribute("data-category") == "category-men") {
        item.classList.add("active");
      }
    } else if (getCookie("activeCategory") == "women") {
      if (item.getAttribute("data-category") == "category-women") {
        item.classList.add("active");
      }
    } else {
      if (item.getAttribute("data-category") == "category-juniors") {
        item.classList.add("active");
      }
    }
  }
});

// Already subscribed newsletter message
if (window.location.href.includes("form_type=customer")) {
  document.querySelector(".already-subscribed").classList.remove("hidden");
  if (document.querySelector("#ContactFooter-error")) {
    document.querySelector("#ContactFooter-error").style.display = "none";
  }
  if (
    !window.location.href.includes("footer") &&
    body.classList.contains("template-index")
  ) {
    window.location.href = window.location.href.split("#")[0] + "#footer";
    location.reload();
  }
}

// If customer is successfulley subscribed newsletter
if (window.location.href.includes("customer_posted")) {
  if (
    !window.location.href.includes("footer") &&
    body.classList.contains("template-index")
  ) {
    window.location.href = "/?customer_posted=true#footer";
  }
}

// Homepage scripts
// if(body.classList.contains('template-index')){
//     // Get list of anchors and categories
//     var fullpageAnchors = []

//     var fpSections = document.querySelectorAll('.image-video-banner, .image-video-button')
//     fpSections.forEach(item => {
//         if(item.classList.contains(`section-${activeCategory}`)) {
//             item.parentNode.classList.add('category-'+item.getAttribute('data-category'))
//             fullpageAnchors.push(item.getAttribute('data-name').replace(/\s/g, ''))
//             }
//     })
//     var anchorsHTML=''
//     fullpageAnchors.forEach(anchor=>{
//         anchorsHTML += `<li><a href="#${anchor}">${anchor.toUpperCase()}</a></li>`
//     })
//     document.querySelector('.full-page-nav-wrapper ul').innerHTML = anchorsHTML
//     document.querySelector('.full-page-nav-wrapper').style.opacity=1
//     fullpageAnchors.push('footer')
//     var listItems = ['.header__icon', 'svg.icon.icon-cart path', '.search-line', '.under_line.hr-underline' , '.new-svg-hamburger','.new-svg-hamburger line','.svg-logo svg path', '.category-right-icon', '.category-right-icon svg path', '.category-left-icon', '.category-left-icon svg path', '.full-page-nav a', '.home-video-banner-text-overlay-inner *', '.ds-close-btn svg path']
//     var allSections = document.querySelectorAll('#fullpage > div')
//     var fullPagewrapper = document.querySelector('#fullpage')
//     var homeFooter = document.querySelector('.category-all')
//     var activeItemsHtml =''
//     fullPagewrapper.innerHTML = ''

//     // Append only active category sections to fullpage
//     allSections.forEach(section=>{
//         if(section.classList.contains(`category-${activeCategory}`)){
//             document.querySelector('#fullpage').appendChild(section)
//         }
//     })
//     document.querySelector('#fullpage').appendChild(homeFooter)

//     new fullpage('#fullpage', {
//         licenseKey: '1465240F-EDE34C50-B10657FF-514504D3',
//         navigation: true,
//         anchors: fullpageAnchors,
//         navigationPosition: 'right',
//         autoScrolling: true,
//         continuousVertical: false,
//         keyboardScrolling: true,
//         scrollingSpeed: 600,
//         slidesNavigation: true,
//         loopBottom: false,
//         normalScrollElements: '.menu-items-container',
//         slidesNavPosition: 'bottom',
//         menu: '.full-page-nav-wrapper',
//         afterLoad: function (origin, destination, direction) {
//             // change colors of sections on the basis of global active color
//             var fpNavActive = ['#fp-nav ul li a.active span', '#fp-slidesNav ul li a.active span']
//             var fpNav = ['#fp-nav ul li a span', '#fp-slidesNav ul li a span']
//             // console.log(destination)
//             var activeAnchor = destination.anchor
//             var navList = document.querySelectorAll('.full-page-nav li a')
//             navList.forEach(item => {
//                 if(item.getAttribute('href') == `#${activeAnchor}`){
//                     item.closest('li').classList.add('active')
//                 }else{
//                     item.closest('li').classList.remove('active')
//                 }
//             })
//             document.querySelector('.search-line').style.borderBottom = '2px solid black'
//             document.querySelector('.search-line').style.borderBottom = '2px solid black'
//             listItems.forEach(item => {
//                 if (item != null || item != undefined) {
//                     document.querySelectorAll(item).forEach(i => {
//                         i.style.color = 'black'
//                         i.style.fill = 'black'
//                         i.style.stroke = 'black'
//                     })
//                 }
//             })
//             fpNav.forEach(item => {
//                 if (item) {
//                     document.querySelectorAll(item).forEach(i => {
//                         i.style.color = 'black'
//                         i.style.backgroundColor = 'transparent'
//                     })
//                 }
//             })
//             var activeSection = destination.item.querySelector('.image-video-banner, .image-video-button')
//             // var menuLinks = document.querySelectorAll(`.menu-drawer__menu li`)
//             // menuLinks.forEach(a => {
//             //     a.style.backgroundColor = 'transparent'
//             // })
//             var footerSection = destination.item.querySelector('.footer')
//             if (footerSection){
//                 document.querySelector('#fp-nav').classList.add('hidden')
//                 document.querySelector('.full-page-nav-wrapper').classList.add('hidden')
//                 document.querySelector('.category-left-icon').classList.add('hidden')
//                 document.querySelector('.category-right-icon').classList.add('hidden')
//                 document.querySelector('.footer-block--newsletter').classList.add('mouseOnInput')
//             }else{
//                 document.querySelector('#fp-nav').classList.remove('hidden')
//                 document.querySelector('.full-page-nav-wrapper').classList.remove('hidden')
//                 document.querySelector('.category-left-icon').classList.remove('hidden')
//                 document.querySelector('.category-right-icon').classList.remove('hidden')

//                 if(document.querySelector('.footer-block--newsletter').classList.contains('mouseOnInput')){
//                     document.querySelector('.footer-block--newsletter').classList.remove('mouseOnInput')
//                 }
//             }

//             if(activeSection){
//                 var getGlobalColor = activeSection.getAttribute('data-globalcolor')
//                 if (getGlobalColor != '' || getGlobalColor != null) {
//                     listItems.forEach(item => {
//                         if (item != null || item != undefined) {
//                             document.querySelectorAll(item).forEach(i => {
//                                 if(i.classList.contains('search-line')){
//                                     i.style.borderBottom = `2px solid ${getGlobalColor}`
//                                 }
//                                 i.style.color = getGlobalColor
//                                 i.style.fill = getGlobalColor
//                                 i.style.stroke = getGlobalColor
//                             })
//                         }
//                     })
//                     fpNavActive.forEach(item => {
//                         if (item) {
//                             document.querySelectorAll(item).forEach(i => {
//                                 i.style.backgroundColor = getGlobalColor
//                             })
//                         }
//                     })
//                     fpNav.forEach(item => {
//                         if (item) {
//                             document.querySelectorAll(item).forEach(i => {
//                                 i.style.color = getGlobalColor
//                             })
//                         }
//                     })
//                     // Sale Timer
//                     document.querySelectorAll('.sale-timer-wrapper *').forEach(s => {
//                         s.style.color = getGlobalColor
//                     })
//                 }
//             }
//         },
//     })

//     document.querySelectorAll('.image-video-banner, .image-video-button').forEach(a => {
//         a.style.opacity = 1
//     })

//     // Autoscroll slides of fullpage
//     // window.addEventListener('load', ()=> {
//     //     setInterval(() => {
//     //         // When user interacting with newsletter
//     //         if(document.querySelector('.footer-block--newsletter').classList.contains('mouseOnInput')){
//     //             return
//     //         }else{
//     //             fullpage_api.moveSectionDown()
//     //         }
//     //     }, 10000)
//     // })

//     // when category change on homepage
//     var rightButton = document.querySelector('.category-right-icon')
//     var leftButton = document.querySelector('.category-left-icon')
//     rightButton.addEventListener('click', () =>{
//         setCookie('activeCategory', rightButton.getAttribute('data-category'), 365)
//         rightButton.querySelector('.icon-spinner').style.display = 'block'
//         rightButton.querySelector('.next-category').style.display = 'none'
//         rightButton.querySelector('.cstm-arrow-icon').style.display = 'none'
//         window.location.href = '/'
//     })
//     leftButton.addEventListener('click', () =>{
//         setCookie('activeCategory', leftButton.getAttribute('data-category'), 365)
//         leftButton.querySelector('.icon-spinner').style.display = 'block'
//         leftButton.querySelector('.prev-category').style.display = 'none'
//         leftButton.querySelector('.cstm-arrow-icon').style.display = 'none'
//         window.location.href = '/'
//     })

// }

// Newsletter form configuration
// document.querySelector('#ContactFooter').addEventListener('submit', (e)=> {
//     e.preventDefault()
//     const formData = new FormData(e.target)
//     var formAction = e.target.getAttribute('action')
//     console.log(formAction, formData)
//         fetch(formAction, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify(
//             formData.forEach(item => {
//                 item
//             })
//           )
//         })
//         .then(response => {
//           return response.json()
//         })
//         .then((data)=>{
//           console.log(data)
//         })
//         .catch((error) => {
//         })
//         .finally(() => {
//         })
// })

// Custom Close Button for Menu Drawer

// var cstmBtn = document.querySelector('.ds-close-btn')
// var origCloseBtn = document.querySelector('.header__icon--summary')
// var click = new Event('click')
// cstmBtn.addEventListener('click',()=>{
//     if(body.classList.contains('template-index')){
//         window.location.href = '/'
//     }else{
//         origCloseBtn.click()
//     }
// })

// Menu Drawer header categories

var specialMenuItems = document.querySelectorAll(".special-menu-item");
specialMenuItems.forEach((item) => {
  item.addEventListener("click", (e) => {
    specialMenuItems.forEach((e) => {
      e.classList.remove("active");
    });
    console.log("hi------>", specialMenuItems);
    item.classList.add("active");
    var menuItem = item.getAttribute("data-menu");
    var mainCategory = menuItem.split("special-menu-");
    setCookie("activeCategory", mainCategory[1], 365);
    var menuListItems = document.querySelectorAll(
      ".special-menu-drawer__submenu"
    );
    menuListItems.forEach((itm) => {
      itm.classList.add("visually-hidden");
    });
    document.querySelector(`.${menuItem}`).classList.remove("visually-hidden");
  });
});

// Detect Have special menu items

var colorItems = document.querySelectorAll(".option_color");
// Loop over them and change colors
colorItems.forEach((item) => {
  var itemColor = item.getAttribute("data-color");
  item.style.color = itemColor;
});

var lastScroll = 0;
window.addEventListener("scroll", () => {
  //   console.log(window.scrollY, "scrolling");
  // if(window.scrollY > 200){
  if (window.scrollY > 40) {
    body.classList.add("sticky");
  } else {
    body.classList.remove("sticky");
  }
  const currentScroll = window.pageYOffset;
  if (currentScroll <= 0) {
    body.classList.remove("scrollUp");
    return;
  }
  if (currentScroll > lastScroll && !body.classList.contains("scrollDown")) {
    body.classList.remove("scrollUp");
    body.classList.add("scrollDown");
  } else if (
    currentScroll < lastScroll &&
    body.classList.contains("scrollDown")
  ) {
    body.classList.remove("scrollDown");
    body.classList.add("scrollUp");
  }
  lastScroll = currentScroll;
});

// Collection page scripts
if (body.classList.contains("template-collection")) {
  var collectionHandle = body.getAttribute("data-coll");

  // Different Banner and writeup for denim collection sub collections
  function collectionDenimBanners() {
    if (
      body.classList.contains("collection-layout-denim") ||
      body.classList.contains("collection-join-plp-denim-template") ||
      body.classList.contains("collection-design-essential-3d")
    ) {
      if (document.querySelector(".sub-collections-wrapper")) {
        document
          .querySelectorAll(".sub-collections-wrapper a")
          .forEach((item) => {
            if (item.classList.contains("active")) {
              var subCol = item.getAttribute("data-value");
              var subCollection = subCol.split("?constraint=");

              if (window.location.href.includes("?constraint=")) {
                var locColl = window.location.href.split("?constraint=");
                if (locColl[1].includes(subCollection[1])) {
                  document
                    .querySelectorAll(
                      ".collection-header:not(.coll-banner-header)"
                    )
                    .forEach((a) => {
                      a.classList.add("hidden");
                      if (a.classList.contains(subCollection[1])) {
                        a.classList.remove("hidden");
                      }
                    });
                  // remove extra banners of 'all' category
                  document
                    .querySelectorAll(".coll-banner-header")
                    .forEach((head) => {
                      head.closest(".layout-banner.coll-main-wrapper").remove();
                    });
                }
              }
            }
          });
      }
      document
        .querySelectorAll(".collection-header:not(.coll-banner-header)")
        .forEach((a) => {
          a.style.opacity = "1";
        });
    }
  }
  collectionDenimBanners();

  // Storing product link in cookies for landing on same product on collection page from product page
  // function landingProductOnCollPage(){
  //     var productLink = document.querySelectorAll('.product-link-main')
  //     productLink.forEach(link => {
  //         link.addEventListener('click', ()=> {
  //             var page = link.closest('.grid-layout').getAttribute('data-pageNumber')
  //             setCookie('collectionHandle', collectionHandle, 365)
  //             var proId = link.closest('.grid-layout').getAttribute('id')
  //             var searchPath = `/collections/${collectionHandle}/?page=${page}#${proId}`
  //             setCookie('productSearchPath', searchPath, 365)
  //             var activeGrid = document.querySelector('.grid-changer .active')
  //             if(activeGrid){
  //                 setCookie('activeGrid', `grid-${activeGrid.innerText}`, 365)
  //             }
  //         })
  //     })
  // }

  // landingProductOnCollPage()

  // Scroll to specific product on collection page
  // if(getCookie('productSearchPath') != null && getCookie('productSearchPath') != 'null' && getCookie('productSearchPath') != ''){
  //     if(window.location.pathname.includes('collections')){
  //         if(collectionHandle == getCookie('collectionHandle')){
  //             window.location.href = getCookie('productSearchPath')
  //             // window.history.pushState({ new: '' },'new state', getCookie('productSearchPath'))
  //         }
  //     }
  // }

  // Header and toolbar sticky on collection page
  // var lastScroll = 0
  // window.addEventListener("scroll", ()=> {
  //     console.log(window.scrollY , 'scrolling');
  //     if(window.scrollY > 200){
  //         body.classList.add('sticky')
  //     }else{
  //         body.classList.remove('sticky')
  //     }
  //     const currentScroll = window.pageYOffset
  //     if (currentScroll <= 0) {
  //         body.classList.remove('scrollUp')
  //         return
  //     }
  //     if (currentScroll > lastScroll && !body.classList.contains('scrollDown')) {
  //         body.classList.remove('scrollUp')
  //         body.classList.add('scrollDown')
  //     }
  //     else if (currentScroll < lastScroll && body.classList.contains('scrollDown')) {
  //         body.classList.remove('scrollDown')
  //         body.classList.add('scrollUp')
  //     }
  //     lastScroll = currentScroll
  // })

  // grid changer on collection page
  function gridOneActive() {
    document
      .querySelector(".main-product-grids-wrapper")
      .classList.add("grid-1");
    document
      .querySelector(".main-product-grids-wrapper")
      .classList.remove("grid-2");
    document
      .querySelector(".main-product-grids-wrapper")
      .classList.remove("grid-4");
    document.querySelector(".grid-2").classList.remove("active");
    document.querySelector(".grid-4").classList.remove("active");
    document.querySelector(".grid-1").classList.add("active");
  }
  function gridTwoActive() {
    document
      .querySelector(".main-product-grids-wrapper")
      .classList.add("grid-2");
    document
      .querySelector(".main-product-grids-wrapper")
      .classList.remove("grid-1");
    document
      .querySelector(".main-product-grids-wrapper")
      .classList.remove("grid-4");
    document.querySelector(".grid-1").classList.remove("active");
    document.querySelector(".grid-4").classList.remove("active");
    document.querySelector(".grid-2").classList.add("active");
  }
  function gridFourActive() {
    document
      .querySelector(".main-product-grids-wrapper")
      .classList.add("grid-4");
    document
      .querySelector(".main-product-grids-wrapper")
      .classList.remove("grid-1");
    document
      .querySelector(".main-product-grids-wrapper")
      .classList.remove("grid-2");
    document.querySelector(".grid-1").classList.remove("active");
    document.querySelector(".grid-2").classList.remove("active");
    document.querySelector(".grid-4").classList.add("active");
  }

  // Activate grid
  function activateGrid() {
    if (document.querySelector(".collection_top-wrapper .grid-changer")) {
      if (
        getCookie("activeGrid") != null &&
        getCookie("activeGrid") != "null" &&
        getCookie("activeGrid") != ""
      ) {
        if (
          getCookie("activeGrid") == "grid-1" &&
          collectionHandle == getCookie("collectionHandle")
        ) {
          gridOneActive();
        } else if (
          getCookie("activeGrid") == "grid-2" &&
          collectionHandle == getCookie("collectionHandle")
        ) {
          gridTwoActive();
        } else if (
          getCookie("activeGrid") == "grid-4" &&
          collectionHandle == getCookie("collectionHandle")
        ) {
          gridFourActive();
        }
      } else {
        gridOneActive();
      }
      setTimeout(() => {
        setCookie("activeGrid", null, { path: "/" });
        setCookie("collectionHandle", null, { path: "/" });
      }, 2000);
    }
  }
  activateGrid();

  window.addEventListener("load", () => {
    setCookie("activeGrid", null, { path: "/" });
    setCookie("collectionHandle", null, { path: "/" });
    setCookie("productSearchPath", null, { path: "/" });
    // window.history.pushState({ new: '' },'new state', window.location.pathname)
  });

  // Grid switcher on click
  if (document.querySelector(".collection_top-wrapper .grid-changer")) {
    document.querySelector(".grid-1").addEventListener("click", () => {
      setCookie("activeGrid", "grid-1", 365);
      setCookie("collectionHandle", collectionHandle, 365);
      gridOneActive();
    });
    document.querySelector(".grid-2").addEventListener("click", () => {
      setCookie("activeGrid", "grid-2", 365);
      setCookie("collectionHandle", collectionHandle, 365);
      gridTwoActive();
    });
    document.querySelector(".grid-4").addEventListener("click", () => {
      setCookie("activeGrid", "grid-4", 365);
      setCookie("collectionHandle", collectionHandle, 365);
      gridFourActive();
    });
  }

  // for collection layout 1 banners
  function layout1Banners(previous) {
    if (!body.classList.contains("collection-revamp-layout-2")) {
      var page = 1,
        pageArr = [];
      document.querySelectorAll(".coll-main-wrapper").forEach((a) => {
        page = Number(a.getAttribute("data-page"));
        pageArr.push(page);
      });
      if (previous == true) {
        page = pageArr[0];
      } else {
        page = page;
      }
      var bannerFirst = document.querySelector(
        `.coll-main-wrapper.page-${page} .layoutOne1.banner-layout`
      );
      var bannerSecond = document.querySelector(
        `.coll-main-wrapper.page-${page} .layoutOne3.banner-layout`
      );
      if (bannerFirst && bannerSecond) {
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .insertBefore(
            document.querySelector(
              `.coll-main-wrapper.page-${page} .layoutOne1.banner-layout`
            ),
            document.querySelector(
              `.coll-main-wrapper.page-${page} .grid-layout:nth-child(1) + .grid-layout`
            )
          );
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .insertBefore(
            document.querySelector(
              `.coll-main-wrapper.page-${page} .layoutOne3.banner-layout`
            ),
            document.querySelector(
              `.coll-main-wrapper.page-${page} .grid-layout:nth-child(10) + .grid-layout`
            )
          );
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .classList.add("both-banners");
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .classList.remove("first-banner");
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .classList.remove("second-banner");
      } else if (bannerFirst && bannerSecond == null) {
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .insertBefore(
            document.querySelector(
              `.coll-main-wrapper.page-${page} .layoutOne1.banner-layout`
            ),
            document.querySelector(
              `.coll-main-wrapper.page-${page} .grid-layout:nth-child(1) + .grid-layout`
            )
          );
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .classList.remove("both-banners");
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .classList.add("first-banner");
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .classList.remove("second-banner");
      } else if (bannerFirst == null && bannerSecond) {
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .insertBefore(
            document.querySelector(
              `.coll-main-wrapper.page-${page} .layoutOne3.banner-layout`
            ),
            document.querySelector(
              `.coll-main-wrapper.page-${page} .grid-layout:nth-child(9) + .grid-layout`
            )
          );
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .classList.remove("both-banners");
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .classList.remove("first-banner");
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .classList.add("second-banner");
      } else {
        document.querySelector(`.coll-main-wrapper.page-${page}`)?.classList.add("no-banner");
        document.querySelector(`.coll-main-wrapper.page-${page}`)?.classList.remove("both-banners");
        document.querySelector(`.coll-main-wrapper.page-${page}`)?.classList.remove("first-banner");
        document.querySelector(`.coll-main-wrapper.page-${page}`)?.classList.remove("second-banner");
      }
    }
  }
  layout1Banners();

  // for collection layout 2 slider 1
  function layout2SliderOne(previous) {
    if (body.classList.contains("collection-revamp-layout-2")) {
      var page = 1,
        pageArr = [];
      document.querySelectorAll(".coll-main-wrapper").forEach((a) => {
        page = Number(a.getAttribute("data-page"));
        pageArr.push(page);
      });
      if (previous == true) {
        page = pageArr[0];
      } else {
        page = page;
      }
      if (
        document.querySelector(
          `.coll-main-wrapper.page-${page} .grid-layout:nth-child(12) + .grid-layout`
        ) &&
        document.querySelector(
          `.coll-main-wrapper.page-${page} .layout-slider.layoutSlider2`
        )
      ) {
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .insertBefore(
            document.querySelector(
              `.coll-main-wrapper.page-${page} .layout-slider.layoutSlider2`
            ),
            document.querySelector(
              `.coll-main-wrapper.page-${page} .grid-layout:nth-child(12) + .grid-layout`
            )
          );
      }
    }
    var swiper = new Swiper(".layout-slider", {
      slidesPerView: "auto",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        init: function (e) {
          var slides = e.slides.length;
          if (slides < 4) {
            e.el.classList.add("products-3");
          }
        },
      },
    });
  }
  layout2SliderOne();

  // for collection layout 2 sliders
  function layout2Sliders(previous) {
    if (body.classList.contains("collection-revamp-layout-2-sliders")) {
      var page = 1,
        pageArr = [];
      document.querySelectorAll(".coll-main-wrapper").forEach((a) => {
        page = Number(a.getAttribute("data-page"));
        pageArr.push(page);
      });
      if (previous == true) {
        page = pageArr[0];
      } else {
        page = page;
      }
      if (
        document.querySelector(
          `.coll-main-wrapper.page-${page} .grid-layout:nth-child(1) + .grid-layout`
        )
      ) {
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .insertBefore(
            document.querySelector(
              `.coll-main-wrapper.page-${page} .layout-slider.layoutSlider1`
            ),
            document.querySelector(
              `.coll-main-wrapper.page-${page} .grid-layout:nth-child(1) + .grid-layout`
            )
          );
      }
      if (
        document.querySelector(
          `.coll-main-wrapper.page-${page} .grid-layout:nth-child(11) + .grid-layout`
        )
      ) {
        document
          .querySelector(`.coll-main-wrapper.page-${page}`)
          .insertBefore(
            document.querySelector(
              `.coll-main-wrapper.page-${page} .layout-slider.layoutSlider2`
            ),
            document.querySelector(
              `.coll-main-wrapper.page-${page} .grid-layout:nth-child(11) + .grid-layout`
            )
          );
      }
    }
    var swiper = new Swiper(".layout-slider", {
      slidesPerView: "auto",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
  layout2Sliders();
}

// footer menu dropdown in main menu drawer on mobile
var footHeader = document.querySelector(".foot-menu-header");
footHeader.addEventListener("click", () => {
  footHeader.classList.toggle("active");
  footHeader
    .closest(".menu-footer")
    .querySelector(".menu-drawer__menu")
    .classList.toggle("hidden");
});

function variantImageURLChanger() {
  // variant image changer and relevant url on product grid
  var color = document.querySelectorAll(
    ".item-image-wrapper:not(.single-swatch)"
  );
  //   console.log(color);
  color.forEach((item) => {
    item.addEventListener("click", () => {
      /* Start 'Dev-M571' Show variant price and compare price */
      var variantPrice = parseInt(item.getAttribute("data-variant-price"));
      var variantComparePrice = parseInt(
        item.getAttribute("data-variant-compare-price")
      );
      var price = item
        .closest(".card-wrapper")
        .querySelector(".price__regular .price-item--regular .money");

      var comparePrice = item
        .closest(".card-wrapper")
        .querySelector(".price-item--sale .money");
      var badgePercentage = item
        .closest(".card-wrapper")
        .querySelector(".price-item--sale .sale-badge");
      var checkOnSale = item.closest(".card-wrapper").querySelector(".price");

      if (variantPrice === variantComparePrice) {
        checkOnSale.classList.remove("price--on-sale");

        item
          .closest(".card-wrapper")
          .querySelector(
            ".price__regular .price-item--regular .money"
          ).innerHTML = `${
          Shopify.currency.active
        } ${variantPrice.toLocaleString()}`;
      } else {
        if (!checkOnSale.classList.contains("price--on-sale")) {
          checkOnSale.classList.add("price--on-sale");
          var badgePercentage = Math.trunc(
            ((variantComparePrice - variantPrice) / variantComparePrice) * 100
          );
          item
            .closest(".card-wrapper")
            .querySelector(
              ".price-item--sale .sale-badge"
            ).innerHTML = `-${badgePercentage}%`;
          item
            .closest(".card-wrapper")
            .querySelector(
              ".price__sale .price-item--regular .money"
            ).innerHTML = `${Shopify.currency.active} ${variantComparePrice}`;
          item
            .closest(".card-wrapper")
            .querySelector(
              ".price__sale .price-item--sale .money"
            ).innerHTML = `${Shopify.currency.active} ${variantPrice}`;
        }
      }
      /* End 'Dev-M571' Show variant price and compare price */
      var variantUrl = item.getAttribute("url");
      var variantColor = item.getAttribute("data-value");
      console.log(variantColor);
      var variantImageId = item.getAttribute("data-img-id");
      var variantImg = item.getAttribute("data-img");
      var otherColors = item
        .closest(".item-swatch")
        .querySelectorAll(".item-image-wrapper");
      otherColors.forEach((v) => {
        v.classList.remove("active");
      });
      item.classList.add("active");
      item
        .closest(".card-wrapper")
        .querySelector(".image-first")
        .setAttribute("srcset", variantImg);
      item
        .closest(".card-wrapper")
        .querySelector(".image-first")
        .setAttribute("src", variantImg);
      item
        .closest(".card-wrapper")
        .querySelector(".image-first")
        .setAttribute("src", variantImg);
      var sizeSwatch = item
        .closest(".card-wrapper")
        .querySelectorAll(".quick-cart-add ul li");
      sizeSwatch.forEach((a) => {
        a.classList.add("hide-variant");
        if (a.getAttribute("data-show") == variantColor) {
          a.classList.remove("hide-variant");
        }
      });

      // for second image
      var filter = `.id-${variantImageId}`;
      var secondImage = item
        .closest(".item-swatch")
        .querySelector(filter)
        .nextElementSibling.getAttribute("data-image");
      item
        .closest(".card-wrapper")
        .querySelector(".image-second")
        .setAttribute("srcset", secondImage);
      item
        .closest(".card-wrapper")
        .querySelector(".image-second")
        .setAttribute("src", secondImage);
      item
        .closest(".card-wrapper")
        .querySelector(".image-second")
        .setAttribute("src", secondImage);

      // for setting active variant url
      item
        .closest(".card-wrapper")
        .querySelectorAll(".product-link-main")
        .forEach((b) => {
          b.setAttribute("href", variantUrl);
        });
    });
  });

  // Set relevant/active url of product variant on pageload
  var activeColor = document.querySelectorAll(
    ".item-image-wrapper.active:not(.single-swatch)"
  );
  activeColor.forEach((a) => {
    var activeUrl = a.getAttribute("url");
    a.closest(".card-wrapper")
      .querySelectorAll(".product-link-main")
      .forEach((b) => {
        b.setAttribute("href", activeUrl);
      });
  });
}
variantImageURLChanger();

function cartPlusSizeSwatches() {
  // Cart plus button and size swatches on product grids
  document.querySelectorAll(".quick-add-cart-wrapper").forEach((item) => {
    item.addEventListener("click", () => {
      if (!body.classList.contains("template-product")) {
        item
          .closest(".card__content")
          .querySelector(".quick-cart-add")
          .classList.add("active");
      } else {
        if (window.innerWidth < 749) {
          var popupdiv = document.querySelector(".size-swatch-recomend-popup");
          console.log(popupdiv, "popupdiv");
          var quickCartAdd = item
            .closest(".card__content")
            .querySelector(".quick-cart-add");
          popupdiv.innerHTML = "";
          popupdiv.appendChild(quickCartAdd.cloneNode(true));
          popupdiv.classList.add("active");
          addToCart();
          soldOutPopup();
          sizeguide();
          // sizeclick()
        } else {
          item
            .closest(".card__content")
            .querySelector(".quick-cart-add")
            .classList.add("active");
        }
      }
      body.classList.add("dropdown-shadow");
      body.classList.add("size-swatch-active");
      body.classList.add("hidescroll");
    });
  });
}
cartPlusSizeSwatches();

function soldOutPopup() {
  // Soldout Popup open/close on product grids
  document
    .querySelectorAll(".quick-cart-add ul li.sold_out")
    .forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        // var size = item.getAttribute('size')
        // var variantId = item.getAttribute('data-id')
        var variantUrl = item.getAttribute("data-url");
        // var variantLink = item.closest('.card__content').querySelector('.product-link-main').getAttribute('href')
        // var finalLink = `${variantLink}&size=${size}&variant=${variantId}`
        var finalLink = `${variantUrl}`;
        document
          .querySelector("#soldout-popup .notify-me")
          .setAttribute("href", finalLink);
        body.classList.add("soldout-popup-active");
        body.classList.add("dropdown-shadow");
        body.style.overflow = "hidden";
        if (!body.classList.contains("template-product")) {
          item.closest(".quick-cart-add").classList.remove("active");
          item.closest(".card-wrapper").style.display = "block";
        } else {
          if (window.innerWidth < 749) {
            document
              .querySelector(".size-swatch-recomend-popup")
              .classList.remove("active");
          } else {
            item.closest(".quick-cart-add").classList.remove("active");
            item.closest(".card-wrapper").style.display = "block";
          }
        }
      });
    });
  document
    .querySelectorAll("#soldout-popup .continue-shopping")
    .forEach((a) => {
      a.addEventListener("click", (e) => {
        e.preventDefault();
        body.classList.remove("soldout-popup-active");
        body.classList.remove("dropdown-shadow");
        body.style.overflow = "inherit";
      });
    });
}
soldOutPopup();

// CartPopup open/close
// document.querySelector('#cart-icon-bubble').addEventListener('click', (e)=> {
//     e.preventDefault()
//     if(body.classList.contains('template-cart')){
//         return
//     }else{
//         body.classList.add('cart-popup-active')
//         body.classList.add('dropdown-shadow')
//     }
// })
document.querySelectorAll(".close-cart").forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    body.classList.remove("cart-popup-active");
    body.classList.remove("hidescroll");
    body.classList.remove("dropdown-shadow");
  });
});

// Dropdown Shadow close button
document.querySelector("#dropdown-shadow").addEventListener("click", (e) => {
  e.preventDefault();

    if (document.querySelector(".product-form__input-mobile.option-size")) {
      document
        .querySelector(".product-form__input-mobile.option-size")
        .classList.remove("active");
    }


  if (body.classList.contains("soldout-popup-active")) {
    body.classList.remove("soldout-popup-active");
  }
  if (body.classList.contains("cart-popup-active")) {
    body.classList.remove("cart-popup-active");
  }
  document.querySelectorAll(".quick-add-cart-wrapper").forEach((item) => {
    if (item) {
      if (!body.classList.contains("template-product")) {
        item
          .closest(".card__content")
          .querySelector(".quick-cart-add")
          .classList.remove("active");
      } else {
        if (window.innerWidth < 749) {
          document
            .querySelector(".size-swatch-recomend-popup")
            .classList.remove("active");
          body.classList.remove("hidescroll");
        } else {
          item
            .closest(".card__content")
            .querySelector(".quick-cart-add")
            .classList.remove("active");
        }
      }
      body.classList.remove("size-swatch-active");
    }
  });
  if (document.querySelector(".template-search__search")) {
    body.classList.remove("predictive-search-active");
  }
  if (document.querySelector(".campaign-popup")) {
    body.classList.remove("campaign-popup-show");
  }
  body.classList.remove("dropdown-shadow");
  body.style.overflow = "inherit";
});

function addToCart() {
  // Add to cart functionality on product grids
  var btn = document.querySelectorAll(".quick-cart-add ul li:not(.sold_out)");
  btn.forEach((item) => {
    item.addEventListener("click", () => {
      var variantId = item.getAttribute("data-id");
      if (!body.classList.contains("template-product")) {
        item.closest(".card-wrapper").classList.add("size-selected");
        item
          .closest(".card-wrapper")
          .setAttribute("data-variant-id", variantId);
      } else {
        if (window.innerWidth < 749) {
          item.classList.add("size-selected");
          item.setAttribute("data-variant-id", variantId);
        }
      }

      if (!item.closest(".complete-look-bundle-section")) {
        var formData = {
          items: [
            {
              id: variantId,
              quantity: 1,
            },
          ],
        };
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => {
            return response.json();
          })
          .then((data) => {
            if (data.status === 422) {
              body.classList.add("cart-error-active");
              document.querySelector("#cart-error-popup").innerText =
                data.description;
              setTimeout(() => {
                body.classList.remove("cart-error-active");
              }, 3000);
            } else {
              cartPopupUpdate();
              setTimeout(() => {
                body.classList.add("cart-popup-active");
                body.classList.add("dropdown-shadow");
              }, 500);
            }
          })
          .catch((error) => {
            body.classList.add("cart-error-active");
            document.querySelector("#cart-error-popup").innerText =
              "An Error Occured. Please try again later";
            setTimeout(() => {
              body.classList.remove("cart-error-active");
            }, 3000);
          })
          .finally(() => {});
      }
      setTimeout(() => {
        if (!body.classList.contains("template-product")) {
          item.closest(".quick-cart-add").classList.remove("active");
          item.closest(".card-wrapper").style.display = "block";
          body.classList.remove("dropdown-shadow");
        } else {
          if (window.innerWidth < 749) {
            document
              .querySelector(".size-swatch-recomend-popup")
              .classList.remove("active");
          } else {
            item.closest(".quick-cart-add").classList.remove("active");
            item.closest(".card-wrapper").style.display = "block";
            body.classList.remove("dropdown-shadow");
          }
        }
      }, 200);
    });
  });
}
addToCart();

// Complete look bundle functionality
document.querySelectorAll(".clb-button").forEach((item) => {
  var sizeSelected = false;
  var variantids = [];
  item.addEventListener("click", (e) => {
    item
      .closest(".clb-main-wrapper")
      .querySelectorAll(".card-wrapper")
      .forEach((card) => {
        if (card.classList.contains("size-selected")) {
          sizeSelected = true;
          card.classList.remove("error-size-show");
        } else {
          sizeSelected = false;
          card.classList.add("error-size-show");
        }
      });
    if (sizeSelected) {
      item
        .closest(".clb-main-wrapper")
        .querySelectorAll(".card-wrapper")
        .forEach((c) => {
          var varId = c.getAttribute("data-variant-id");
          variantids.push({
            id: varId,
            quantity: 1,
          });
        });
      var formData = {
        items: variantids,
      };
      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.status === 422) {
            body.classList.add("cart-error-active");
            document.querySelector("#cart-error-popup").innerText =
              data.description;
            setTimeout(() => {
              body.classList.remove("cart-error-active");
            }, 3000);
          } else {
            cartPopupUpdate();
            setTimeout(() => {
              body.classList.add("cart-popup-active");
              body.classList.add("dropdown-shadow");
            }, 500);
          }
        })
        .catch((error) => {
          body.classList.add("cart-error-active");
          document.querySelector("#cart-error-popup").innerText =
            "An Error Occured. Please try again later";
          setTimeout(() => {
            body.classList.remove("cart-error-active");
          }, 3000);
        })
        .finally(() => {});
    } else {
      document.querySelectorAll(".error-size-show").forEach((a) => {
        a.querySelector(".select-size-error").style.display = "block";
        setTimeout(() => {
          a.querySelector(".select-size-error").style.display = "none";
        }, 2000);
      });
      item
        .closest(".clb-main-wrapper")
        .querySelector(".all-size-error").style.display = "block";
      setTimeout(() => {
        item
          .closest(".clb-main-wrapper")
          .querySelector(".all-size-error").style.display = "none";
      }, 2000);
    }
  });
});

function removeCartItem() {
  // Remove from cart
  var btn = document.querySelectorAll(".btn-remove");
  btn.forEach((item) => {
    item.addEventListener("click", (e) => {
      e.preventDefault();
      var lineId = item.closest(".item").getAttribute("data-line");
      var formData = {
        line: lineId,
        quantity: 0,
      };
      fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          if (data.status === 422) {
          } else {
            cartPopupUpdate();
          }
        })
        .catch((error) => {
          body.classList.add("cart-error-active");
          document.querySelector("#cart-error-popup").innerText =
            "An Error Occured. Please try again later";
          setTimeout(() => {
            body.classList.remove("cart-error-active");
          }, 3000);
        });
    });
  });
}
removeCartItem();

function cartPopupUpdate() {
  // for updating cart popup
  fetch("/cart.js", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .then((cart) => {
      var lineItems = [];
      if (document.querySelector(".mini-products-list")) {
        document.querySelector(".mini-products-list").innerHTML = "";
      }

      var cartCounter = cart.item_count;
      console.log(cartCounter, "cartCounter");
      document.querySelectorAll(".cart-counter").forEach((counters) => {
        counters.innerText = cartCounter;
      });
      var totalPrice = priceFormatting(cart.total_price / 100);
      cart.items.forEach((item, i) => {
        var itemPrice = priceFormatting(item.price / 100);
        var lineItemDetails = `<li class="item" data-id="${
          item.id
        }" data-line="${i + 1}">
                <a href="${item.url}" class="product-image">
                <img loading="lazy" src="${item.image}" alt="${item.title}">
                </a>
                <div class="product-details">
                <a href="javascript:void(0)" title="Remove" class="btn-remove">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none">
                        <path d="M1.5 12.25C1.5 13.075 2.175 13.75 3 13.75H9C9.825 13.75 10.5 13.075 10.5 12.25V3.25H1.5V12.25ZM3 4.75H9V12.25H3V4.75ZM8.625 1L7.875 0.25H4.125L3.375 1H0.75V2.5H11.25V1H8.625Z" fill="black"></path>
                    </svg>
                </a>
                <a class="product-name" href="${item.url}">${
          item.product_title
        }</a>
                <div class="option">
                <small>${item.variant_title}</small>
                </div>
                <div class="cart-collateral">
                    <div class="dev1 cart-quantity">${item.quantity}X</div>
                    <span class="price">
                    <span class="money">PKR ${itemPrice}</span>
                    </span>
                </div>
                </div>
            </li>`;
        lineItems.push(lineItemDetails);
      });
      if (document.querySelector(".mini-products-list")) {
        document.querySelector(".mini-products-list").innerHTML =
          lineItems.join("");
      }
      if (document.querySelector(".total .price")) {
        document.querySelector(".total .price").innerText = `PKR ${totalPrice}`;
      }

      if (cartCounter > 0) {
        // document.querySelector('.cart-count-bubble').classList.remove('hidden')
        document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
          bubble.classList.remove("hidden");
        });
        if (document.querySelector("#dropdown-cart .has-items")) {
          document.querySelector("#dropdown-cart .has-items").classList.remove("hidden");
        }
        if (document.querySelector("#dropdown-cart .no-items")) {
          document.querySelector("#dropdown-cart .no-items").classList.add("hidden"); 
        }
      } else {
        // document.querySelector('.cart-count-bubble').classList.add('hidden')
        document.querySelectorAll(".cart-count-bubble").forEach((bubble) => {
          bubble.classList.add("hidden");
        });
        if (document.querySelector("#dropdown-cart .has-items")) {
          document.querySelector("#dropdown-cart .has-items").classList.add("hidden");
        }
        if (document.querySelector("#dropdown-cart .no-items")) {
           document.querySelector("#dropdown-cart .no-items").classList.remove("hidden");
        }
 
      }
    })
    .catch((error) => {
      body.classList.add("cart-error-active");
      document.querySelector("#cart-error-popup").innerText =
        "An Error Occured. Please try again later";
      setTimeout(() => {
        body.classList.remove("cart-error-active");
      }, 3000);
    })
    .finally(() => {
      removeCartItem();
    });
}

function priceFormatting(price) {
  // for formatting price
  var formatPrice = new Intl.NumberFormat("en-PK", {
    maximumSignificantDigits: 4,
  }).format(price);
  return formatPrice;
}

// Collection and search page scripts
if (
  body.classList.contains("template-collection") ||
  body.classList.contains("template-search")
) {
  // Load More AND Load previous functionality on collection page and search page

  var loadmore_btn = document.querySelector(".load-more-cstm-btn");
  var products_on_page = document.querySelector("#product-grid");
  var loadmore_spinner = document.querySelector(".load-more-spinner");
  var no_more = document.querySelector(".no-more-cstm");
  if (no_more) {
    no_more.style.display = "none";
  }
  if (document.querySelector(".loadmore-less")) {
    no_more.style.display = "block";
  }
  if (loadmore_spinner) {
    loadmore_spinner.style.display = "none";
  }
  var next_url = products_on_page.getAttribute("data-next-url");
  if (!next_url) {
    no_more.style.display = "block";
  }

  var loadprev_btn = document.querySelector(".load-prev-cstm-btn");
  var loadprev_spinner = document.querySelector(".load-prev-spinner");
  var prev_url = products_on_page.getAttribute("data-prev-url");

  function loadPreviousProducts() {
    if (prev_url) {
      fetch(prev_url)
        .then((response) => {
          loadprev_spinner.style.display = "inline-block";
          loadprev_btn.style.display = "none";
          return response.text();
        })
        .then((data) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data, "text/html");
          var return_html = doc.body;
          var main_html = return_html.querySelector("#product-grid");
          var main_html_child =
            main_html.querySelectorAll(".coll-main-wrapper");
          var new_prev_url = main_html.getAttribute("data-prev-url");
          if (new_prev_url) {
            loadprev_spinner.style.display = "inline-block";
            loadprev_btn.style.display = "none";
          }
          prev_url = new_prev_url;
          setTimeout(() => {
            main_html_child.forEach(function (value, index) {
              document
                .querySelector(".main-product-grids-wrapper")
                .prepend(value);
            });
            loadprev_spinner.style.display = "none";
            if (new_prev_url) {
              loadprev_btn.style.display = "inline-flex";
            } else {
              products_on_page.setAttribute("data-prev-url", "");
              loadprev_btn.style.display = "none";
              prev_url = "";
              loadprev_btn.closest(".loadprev-cstm").remove();
            }
            cartPlusSizeSwatches();
            soldOutPopup();
            addToCart();
            variantImageURLChanger();
            if (body.classList.contains("template-collection")) {
              window.scrollBy(
                0,
                document.querySelectorAll(".coll-main-wrapper")[0].clientHeight
              );
              // landingProductOnCollPage()
              layout1Banners(true);
              layout2SliderOne(true);
              layout2Sliders(true);
              collectionDenimBanners();
              //plpCollectionSLider();
            }
          }, 100);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  if (document.querySelectorAll("#load-prev-cstm-btn").length > 0) {
    document
      .querySelector("#load-prev-cstm-btn")
      .addEventListener("click", () => {
        loadPreviousProducts();
      });
  }

  function loadMoreProducts() {
    if (next_url) {
      fetch(next_url)
        .then((response) => {
          loadmore_btn.style.display = "none";
          loadmore_spinner.style.display = "inline-block";
          return response.text();
        })
        .then((data) => {
          var parser = new DOMParser();
          var doc = parser.parseFromString(data, "text/html");
          var return_html = doc.body;
          var main_html = return_html.querySelector("#product-grid");
          var main_html_child =
            main_html.querySelectorAll(".coll-main-wrapper");
          var new_url = main_html.getAttribute("data-next-url");
          loadmore_spinner.style.display = "none";
          if (new_url) {
            loadmore_spinner.style.display = "inline-block";
            loadmore_btn.style.display = "none";
          }
          next_url = new_url;
          setTimeout(() => {
            main_html_child.forEach(function (value, index) {
              document
                .querySelector(".main-product-grids-wrapper")
                .append(value);
            });
            loadmore_spinner.style.display = "none";
            if (new_url) {
              loadmore_btn.style.display = "block";
            } else {
              products_on_page.setAttribute("data-next-url", "");
              loadmore_btn.classList.remove("load-more-cstm-btn");
              loadmore_btn = "";
              next_url = "";
              no_more.style.display = "block";
            }
            cartPlusSizeSwatches();
            soldOutPopup();
            addToCart();
            variantImageURLChanger();

            if (body.classList.contains("template-collection")) {
              // landingProductOnCollPage()
              layout1Banners(false);
              layout2SliderOne(false);
              layout2Sliders(false);
              collectionDenimBanners();
             // plpCollectionSLider();
            }
          }, 100);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  if (document.querySelectorAll("#load-more-cstm-btn").length > 0) {
    document
      .querySelector(".load-more-cstm-btn")
      .addEventListener("click", () => {
        loadMoreProducts();
      });
  }
  var btnClick = new Event("click");
  document.addEventListener("scroll", function () {
    var collectionTplElm = document.querySelector(".collection_top-wrapper");
    var collectionTop = window.innerHeight;
    var collectionHeight = collectionTplElm.clientHeight;
    var posTop = collectionTop + collectionHeight - window.innerHeight;

    if (
      window.pageYOffset > posTop - 5000 &&
      window.pageYOffset < posTop + 10000
    ) {
      if (loadmore_btn) {
        if (loadmore_btn.classList.contains("btn-disabled")) {
        } else {
          loadmore_btn.dispatchEvent(btnClick);
          loadmore_btn.classList.add("btn-disabled");
          setTimeout(function () {
            if (loadmore_btn) {
              loadmore_btn.classList.remove("btn-disabled");
            }
          }, 3000);
        }
      }
    }
    if (window.pageYOffset < 600) {
      if (loadprev_btn) {
        if (loadprev_btn.classList.contains("btn-disabled")) {
        } else {
          loadprev_btn.dispatchEvent(btnClick);
          loadprev_btn.classList.add("btn-disabled");
          setTimeout(function () {
            if (loadprev_btn) {
              loadprev_btn.classList.remove("btn-disabled");
            }
          }, 3000);
        }
      }
    }
  });
}

// Window load on iphone and other devices when required
// window.onpageshow = function(event) {
//   if (event.persisted) {
//     window.location.reload()
//   }
// }

// function plpCollectionSLider() {

//   $(".color-more-child-wrapper").not('.slick-initialized').slick({
//     dots: false,
//     arrows: false,
//     // centerMode: true,
//     // centerPadding: '100px',
//     infinite: false,
//     slidesToShow: 4.5,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: {
//           // centerMode: true,
//           // centerPadding: '30px',
//           slidesToShow: 2.5
//         }
//       }
//     ]
//   });

// }

// plpCollectionSLider();
